// extracted by mini-css-extract-plugin
module.exports = {"labelSpecial":"classes_labelSpecial__MpmfS","buttonsContainer":"classes_buttonsContainer__1zQX_"};